module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0101.jpg?v=d8b68643";